"use client"
import React from "react";
import { Modal } from "react-bootstrap";
import { useMediaQuery } from "react-responsive";
import CrmPauREListingView from "@/components/crm/pau/re/CrmPauREListingView";

// An RE listing's full details over the locator map
const REListingModal = ({ name, reListing, onHide }) => {
  const isSm = useMediaQuery({ query: "(max-width: 767.98px)" });
  return (
    <Modal
      show={reListing != null}
      onHide={onHide}
      size="xl"
      fullscreen={isSm}
      scrollable={true}
    >
      <Modal.Header closeButton>
        <div className="navbar-brand-logo branded" />
      </Modal.Header>
      <Modal.Body>
        {reListing && <CrmPauREListingView name={name} reListing={reListing} />}
        <br />
      </Modal.Body>
    </Modal>
  );
};

export default REListingModal;
